import React from "react";

const logline = <p>When their father disappears at sea just before Christmas, four siblings reunite in their Vancouver home, only to uncover a shocking will, dark secrets behind the family’s Christmas-light empire, and the unsettling possibility he may still be alive.</p>;

export default logline;